export type UnityProps = {
	type?: string;
};

export const REQ_UNITY = 'REQ_UNITY';
export const REMOVE_UNITY = 'REMOVE_UNITY';
